import { useMutation, useQueryClient } from '@tanstack/react-query'
import { submitSire, unsubmitSire } from '../services/reservation-guests/api'
import { reservationQueries } from '../services/reservations/queries'

export function useConfirmSireForGuest() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: submitSire,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: reservationQueries.all() })
    },
  })
}

export function useUnconfirmSireForGuest() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: unsubmitSire,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: reservationQueries.all() })
    },
  })
}
